module.exports = __webpack_public_path__ + "acv_slide_desktop.webp";